import React, {Component} from 'react';
import {Icon} from 'semantic-ui-react';
import moment from 'moment';
import _ from 'lodash';
import {catalogDateFormat} from '../../../common/constants/datesFormat';
import {transactionStatus} from '../../../common/dictionaries/parameters';


class ContentMessage extends Component {
  getIconProperties(statusCode) {
    if (statusCode !== transactionStatus.completed) {
      return {'color': 'orange', 'name': 'exclamation triangle'};
    }

    return {'color': 'green', 'name': 'check circle outline'};
  }

  renderIcon(statusCode) {
    const properties = this.getIconProperties(statusCode);

    return (
      <div>
        <Icon name={properties.name} size='massive' color={properties.color} />
      </div>
    );
  }

  renderDate(transaction) {
    const {statusCode, date} = transaction;
    let labelText = '';

    switch (statusCode) {
      case transactionStatus.backup:
      case transactionStatus.processing:
      case transactionStatus.restoring:
        labelText = 'Fecha de Inicio: ';
        break;
      case transactionStatus.failed:
        labelText = 'Fecha del Error: ';
        break;
      default:
        labelText = 'Última carga: ';
    }

    return (
      <React.Fragment>
        <strong>{labelText}</strong>
        {moment(date).format(catalogDateFormat)}
      </React.Fragment>
    );
  }
  
  render() {
    const {transactionStatus} = this.props;

    if (_.isEmpty(transactionStatus)) {
      return (
        <div className='content'>
          <div className='comment'>
            <strong>No se ha procesado ningún catálogo</strong>
          </div>
        </div>
      );
    }
    
    return (
      <div className='content'>
        {this.renderIcon(transactionStatus.statusCode)}
        <div className='comment'>
          <strong>{transactionStatus.comment}</strong>
        </div>
        <div className='user'>
          <Icon name='user' />
          {transactionStatus.user}
        </div>
        <div className='date'>
          {this.renderDate(transactionStatus)}
        </div>
      </div>
    );
  }
}

export default ContentMessage;
